import { useState, useEffect } from "react";
import { API_BASE } from "../config";
import { apiFetch } from "../utilities/apiFetch";

const useBusquedaAlumno = (cajeroId, plantelId) => {
  const [tipoBusqueda, setTipoBusqueda] = useState("matricula"); 
  const [criterioBusqueda, setCriterioBusqueda] = useState("");
  const [filtroSemestre, setFiltroSemestre] = useState(""); 
  const [filtroPlantelOrigen, setFiltroPlantelOrigen] = useState("");
  const [filtroPeriodo, setFiltroPeriodo] = useState(""); 
  const [resultados, setResultados] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [mensaje, setMensaje] = useState("");

  // Sincroniza el filtro del plantel inicial cuando el cajero inicia sesión
  useEffect(() => {
    if (plantelId) {
      setFiltroPlantelOrigen(plantelId);
    }
  }, [plantelId]);

  const cambiarTipoBusqueda = (tipo) => {
    setTipoBusqueda(tipo);
    setCriterioBusqueda("");
    setFiltroSemestre("");
    setFiltroPlantelOrigen(plantelId);
    setFiltroPeriodo("");
    setResultados([]);
    setMensaje("");
  };

  const handleBuscarAlumno = async (e) => {
    if (e) e.preventDefault();
    const busquedaLimpia = criterioBusqueda.trim();

    if (busquedaLimpia === "") {
      setMensaje("Por favor, ingresa un dato para buscar.");
      return;
    }

    if (tipoBusqueda === "matricula") {
      const regexMatricula = /^\d{14}$/;
      if (!regexMatricula.test(busquedaLimpia)) {
        setMensaje("⚠️ La matrícula debe contener exactamente 14 números.");
        return;
      }
    } else if (tipoBusqueda === "nombre") {
      if (busquedaLimpia.length < 3) {
        setMensaje("⚠️ Ingresa al menos 3 letras (ej. un apellido) para buscar.");
        return;
      }
    }

    setIsLoading(true);
    setMensaje("");
    setResultados([]);

    let formData = new FormData();
    formData.append("criterio", busquedaLimpia);
    formData.append("tipo_busqueda", tipoBusqueda); 
    formData.append("cajero_id", cajeroId);
    
    if (tipoBusqueda === "nombre") {
      formData.append("filtro_semestre", filtroSemestre);
      formData.append("filtro_plantel", filtroPlantelOrigen || ""); 
      formData.append("filtro_periodo", filtroPeriodo); 
    } else {
      formData.append("filtro_semestre", "");
      formData.append("filtro_plantel", ""); 
      formData.append("filtro_periodo", ""); 
    }

    try {
      const res = await apiFetch(`${API_BASE}/wMultipagosBuscarAlumnoCajero.php`, {
        method: "POST",
        body: formData
      });

      if (!res.ok) throw new Error(`HTTP Error: ${res.status}`);
      
      const data = await res.json();

      if (data.success) {
        if (data.data && data.data.length > 0) {
          setResultados(data.data);
        } else {
          setMensaje(data.mensaje || "No se encontraron alumnos con estos filtros."); 
        }
      } else {
        setMensaje(data.mensaje || "Error en la búsqueda.");
      }
    } catch (error) {
      console.error("Error:", error);
      setMensaje("Error de red. Revisa tu conexión.");
    } finally {
      setIsLoading(false);
    }
  };

  return {
    tipoBusqueda,
    criterioBusqueda,
    setCriterioBusqueda,
    filtroSemestre,
    setFiltroSemestre,
    filtroPlantelOrigen,
    setFiltroPlantelOrigen,
    filtroPeriodo,
    setFiltroPeriodo,
    resultados,
    setResultados,
    isLoading,
    mensaje,
    setMensaje,
    cambiarTipoBusqueda,
    handleBuscarAlumno
  };
};

export default useBusquedaAlumno;